import {
  Box,
  type BoxProps,
  Tab as MuiTab,
  type TabProps,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Root = styled(Box)<BoxProps>`
  width: 100%;
`;

export const Tab = styled(MuiTab)<TabProps>`
  text-transform: none;
  font-weight: 600;
  font-size: 14px;
`;

export const DetailsPanel = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor:
    theme.palette.mode === "dark"
      ? alpha(theme.palette.common.white, 0.06)
      : theme.palette.secondary.main,
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(1),
}));
